import { render } from "./PanelHeader.vue?vue&type=template&id=feeea0fe&scoped=true&ts=true"
import script from "./PanelHeader.vue?vue&type=script&lang=ts"
export * from "./PanelHeader.vue?vue&type=script&lang=ts"

import "./PanelHeader.vue?vue&type=style&index=0&id=feeea0fe&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feeea0fe"]])

export default __exports__